module.exports = __webpack_public_path__ + "img/block-bg.8bec90d0.png";